module.exports = __webpack_public_path__ + "static/first-0f45f31a199838d877e40921ec298cee.jpg";